import { isPlainObject } from "lodash-es";
import { getDeviceId, getDecodedTime } from "./helpers";

export function getDemoTelemetry(demoMessages) {
  if (!Array.isArray(demoMessages)) throw new Error(`Expected array of messages`);
  const telemetry = {};
  let total = 0;
  for (const msg of demoMessages) {
    const { payload } = msg;
    if (!isPlainObject(payload)) continue;
    const deviceId = msg.deviceId || getDeviceId(payload);
    if (!deviceId) continue;
    if (isPlainObject(payload.signal)) {
      const measTypes = ['sinr', 'rsrp', 'rsrq', 'rssi'];
      for (const measType of measTypes) {
        if (!Object.keys(payload.signal).includes(measType)) continue;
        if (!(deviceId in telemetry)) {
          telemetry[deviceId] = {};
        }
        if (!Object.keys(telemetry[deviceId]).includes(measType)) {
          telemetry[deviceId][measType] = [];
        }
        const meas = {
          measurementTime: getDecodedTime(msg),
          [measType]: payload.signal[measType],
        };
        telemetry[deviceId][measType].push(meas);
        total++;
      }
    }
  }
  return { telemetry, total };
}
